import React, { useEffect, useState } from "react";
import { Badge, Button, Form } from "react-bootstrap";
import moment from "moment";
import RetireModal from "./retireModal";
import CreateEditModal from "./createModal";
import ViewModal from "./viewModal";
import { DUMMY_IMPRESSES } from "./impressData";
import axios from "axios";
import { toast } from "react-toastify";
import { switchEndpoint } from "../../../../../redux/actions/endpoints";
import capitalize from "../../../../../capitalize";
import { storage } from "../../../../../scopedStorage";

const TABS = ["all", "pending", "approved", "retired", "declined"];

const STATUS_VARIANT = {
  pending: "warning",
  approved: "success",
  retired: "secondary",
  declined: "danger",
};

const ImpressComponent = () => {
  const [impresses, setImpresses] = useState([]);
  // const [impresses, setImpresses] = useState(DUMMY_IMPRESSES);
  const [search, setSearch] = useState("");
  const [activeTab, setActiveTab] = useState("all");

  const [viewModal, setViewModal] = useState({ show: false, impress: null });
  const [editModal, setEditModal] = useState({ show: false, impress: null });
  const [retireModal, setRetireModal] = useState({
    show: false,
    impress: null,
  });
  const [createModal, setCreateModal] = useState(false);

  // ── Counts ────────────────────────────────────────────────────────────────
  const counts = {
    total: impresses.length,
    pending: impresses.filter((i) => i.status === "pending").length,
    approved: impresses.filter((i) => i.status === "approved").length,
    retired: impresses.filter((i) => i.status === "retired").length,
    declined: impresses.filter((i) => i.status === "declined").length,
  };

  // ── Filter ────────────────────────────────────────────────────────────────
  const filtered = impresses.filter((imp) => {
    const matchesTab = activeTab === "all" || imp.status === activeTab;
    const matchesSearch =
      !search.trim() ||
      imp.name.toLowerCase().includes(search.toLowerCase()) ||
      imp.type.toLowerCase().includes(search.toLowerCase());
    return matchesTab && matchesSearch;
  });

  // ── Handlers ──────────────────────────────────────────────────────────────
  const handleCreate = async (form) => {
    const newImpress = {
      id: Date.now(),
      ...form,
      status: "pending",
      date: moment().format("YYYY-MM-DD"),
      proof: null,
    };

    const token = storage.getItem("token");
    // console.log(form);
    await axios.post(
      `${switchEndpoint}/collection-center/imprest-requests`,
      form,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    handleGetImpress();
    setImpresses((prev) => [newImpress, ...prev]);
    setCreateModal(false);
    toast.success("Imprest created successfully", {
      position: "top-right",
      autoClose: 3000,
      theme: "light",
    });
  };

  // const handleEdit = async (form) => {
  //   const token = storage.getItem("token");
  //   await axios.patch(
  //     `${switchEndpoint}/collection-center/update-imprest-update/${editModal.impress.id}`,
  //     form,
  //     {
  //       headers: { Authorization: `Bearer ${token}` },
  //     },
  //   );
  //   setImpresses((prev) =>
  //     prev.map((imp) =>
  //       imp.id === editModal.impress.id ? { ...imp, ...form } : imp,
  //     ),
  //   );
  //   setEditModal({ show: false, impress: null });
  //   toast.success("Impress saved successfully", {
  //     position: "top-right",
  //     autoClose: 3000,
  //     theme: "light",
  //   });
  // };

  const handleEdit = async (form) => {
  const token = storage.getItem("token");
  try {
    await axios.patch(
      `${switchEndpoint}/collection-center/update-imprest-update/${editModal.impress.id}`,
      form,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    setImpresses((prev) =>
      prev.map((imp) =>
        imp.id === editModal.impress.id ? { ...imp, ...form } : imp,
      ),
    );
    setEditModal({ show: false, impress: null });
    toast.success("Imprest saved successfully", {
      position: "top-right",
      autoClose: 3000,
      theme: "light",
    });
  } catch (error) {
    toast.error(error?.response?.data?.message || "Failed to update imprest", {
      position: "top-right",
      autoClose: 3000,
      theme: "light",
    });
  }
};

  const uploadAndRetire = async ({ notes, proof }) => {
    const token = storage.getItem("token");
    const impress = retireModal.impress;

    try {
      // Step 1 — upload image
      const uploadForm = new FormData();
      uploadForm.append("file", proof);

      const uploadResponse = await axios.post(
        `${switchEndpoint}/upload-image`,
        uploadForm,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const imageUrl = uploadResponse.data.image_url;
      // console.log("uploaded image url:", imageUrl);

      // Step 2 — retire impress with image url
      const retireResponse = await axios.post(
        `${switchEndpoint}/collection-center/retire-imprest/${impress.id}`,
        {
          retirement_receipt: imageUrl,
          retired_amount: impress?.amount,
          retirement_notes: notes,
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      // console.log("retire response:", retireResponse.data);

      setImpresses((prev) =>
        prev.map((imp) =>
          imp.id === impress.id
            ? { ...imp, status: "retired", retirement_receipt: imageUrl }
            : imp,
        ),
      );
      setRetireModal({ show: false, impress: null });
      toast.success("Impress retired successfully", {
        position: "top-right",
        autoClose: 3000,
        theme: "light",
      });
    } catch (error) {
      // console.log("error:", error.response?.data);
      toast.error(
        error?.response?.data?.message || "Failed to retire imprest",
        {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
        },
      );
    }
  };

  const handleGetImpress = () => {
    const token = storage.getItem("token");
    // setIsloading(true);
    axios
      .get(`${switchEndpoint}/collection-center/imprest-requests`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        let result = response.data.data;
        // console.log(result);
        setImpresses(result);
        // setIsloading(false);
      })
      .catch((error) => {
        // setIsloading(false);
        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          pauseOnHover: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  useEffect(() => {
    handleGetImpress();
  }, []);
  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <main>
      <div style={{ padding: 24 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 20,
          }}
        >
          <div>
            <h5 style={{ margin: 0, fontWeight: 600 }}>Imprest</h5>
            <p style={{ margin: 0, fontSize: 13, color: "#6b7280" }}>
              Manage your imprest requests
            </p>
          </div>
          <Button variant="dark" size="sm" onClick={() => setCreateModal(true)}>
            + New Imprest
          </Button>
        </div>

        {/* ── Summary cards ── */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            gap: 12,
            marginBottom: 20,
          }}
        >
          {[
            {
              label: "Total Requests",
              value: counts.total,
              color: "#111827",
              bg: "#f9fafb",
            },
            {
              label: "Pending",
              value: counts.pending,
              color: "#d97706",
              bg: "#fef3c7",
            },
            {
              label: "Approved",
              value: counts.approved,
              color: "#16a34a",
              bg: "#dcfce7",
            },
            {
              label: "Retired",
              value: counts.retired,
              color: "#6b7280",
              bg: "#f3f4f6",
            },
            {
              label: "Declined",
              value: counts.declined,
              color: "#dc2626",
              bg: "#fee2e2",
            },
          ].map(({ label, value, color, bg }) => (
            <div
              key={label}
              style={{
                background: bg,
                borderRadius: 10,
                padding: "14px 16px",
                border: "1px solid #f3f4f6",
              }}
            >
              <p style={{ margin: 0, fontSize: 12, color: "#6b7280" }}>
                {label}
              </p>
              <p style={{ margin: 0, fontSize: 22, fontWeight: 600, color }}>
                {value}
              </p>
            </div>
          ))}
        </div>

        {/* ── Filter bar ── */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: 10,
            padding: "10px 14px",
            marginBottom: 14,
            flexWrap: "wrap",
            gap: 10,
          }}
        >
          <div style={{ display: "flex", alignItems: "baseline", gap: 6 }}>
            <span style={{ fontSize: 13, fontWeight: 600 }}>My Imprests</span>
            <span style={{ fontSize: 11, color: "#6b7280" }}>
              ({filtered.length})
            </span>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <Form.Control
              size="sm"
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ width: 180 }}
            />

            <div
              style={{
                display: "flex",
                border: "1px solid #e5e7eb",
                borderRadius: 6,
                overflow: "hidden",
              }}
            >
              {TABS.map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  style={{
                    fontSize: 11,
                    fontWeight: 500,
                    padding: "4px 10px",
                    border: "none",
                    borderRight: "1px solid #e5e7eb",
                    cursor: "pointer",
                    textTransform: "capitalize",
                    background: activeTab === tab ? "#111827" : "#f9fafb",
                    color: activeTab === tab ? "#fff" : "#6b7280",
                    whiteSpace: "nowrap",
                  }}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* ── Impress list ── */}
        {filtered.length === 0 ? (
          <div
            style={{
              textAlign: "center",
              padding: "48px 0",
              color: "#9ca3af",
              fontSize: 13,
            }}
          >
            No imprests found.
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {filtered.map((imp) => (
              <div
                key={imp.id}
                style={{
                  background: "#fff",
                  border: "1px solid #e5e7eb",
                  borderRadius: 10,
                  padding: "12px 16px",
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                }}
              >
                {/* Info */}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <p style={{ margin: 0, fontSize: 13, fontWeight: 600 }}>
                    {imp.name}
                  </p>
                  <div
                    style={{
                      display: "flex",
                      gap: 12,
                      marginTop: 3,
                      fontSize: 11,
                      color: "#6b7280",
                      flexWrap: "wrap",
                    }}
                  >
                    <span>{imp.type}</span>
                    <span>{imp.function}</span>
                    <span>{moment(imp.date).format("DD MMM YYYY")}</span>
                  </div>
                </div>

                {/* Amount */}
                <p
                  style={{
                    margin: 0,
                    fontSize: 13,
                    fontWeight: 600,
                    flexShrink: 0,
                  }}
                >
                  ₦{Number(imp.amount).toLocaleString()}
                </p>

                {/* Status badge */}
                <Badge
                  variant={STATUS_VARIANT[imp.status] || "secondary"}
                  pill
                  style={{ flexShrink: 0 }}
                  className="px-4 py-2"
                >
                  {capitalize(imp.status)}
                </Badge>

                {/* Action buttons */}
                <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    onClick={() => setViewModal({ show: true, impress: imp })}
                  >
                    View
                  </Button>

                  {imp.status === "pending" && (
                    <Button
                      size="sm"
                      variant="dark"
                      onClick={() => setEditModal({ show: true, impress: imp })}
                    >
                      Edit
                    </Button>
                  )}

                  {imp.status === "approved" && (
                    <Button
                      size="sm"
                      variant="dark"
                      onClick={() =>
                        setRetireModal({ show: true, impress: imp })
                      }
                    >
                      Retire
                    </Button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* ── Modals ── */}
        <ViewModal
          show={viewModal.show}
          impress={viewModal.impress}
          onHide={() => setViewModal({ show: false, impress: null })}
        />

        <CreateEditModal
          show={createModal}
          impress={null}
          onHide={() => setCreateModal(false)}
          onSubmit={handleCreate}
        />

        <CreateEditModal
          show={editModal.show}
          impress={editModal.impress}
          onHide={() => setEditModal({ show: false, impress: null })}
          onSubmit={handleEdit}
        />

        <RetireModal
          show={retireModal.show}
          impress={retireModal.impress}
          onHide={() => setRetireModal({ show: false, impress: null })}
          onSubmit={uploadAndRetire}
        />
      </div>
    </main>
  );
};

export default ImpressComponent;
